export interface PartnerItem {
	name: string
	img: string
}

export const PUBLISHERS_PARTNERS: PartnerItem[] = [
	{
		name: 'beeline',
		img: '/images/sections/partners/beeline.png',
	},
	{
		name: 'google',
		img: '/images/sections/partners/google.png',
	},
	{
		name: 'wunder',
		img: '/images/sections/partners/wunder.svg',
	},
	{
		name: 'meta',
		img: '/images/sections/partners/meta.png',
	},
	{
		name: 'yandex',
		img: '/images/sections/partners/yandex.svg',
	},
	{
		name: 'janymda',
		img: '/images/sections/partners/janymda.png',
	},
	{
		name: 'hambi',
		img: '/images/sections/partners/hambi.svg',
	},
	{
		name: 'beetv',
		img: '/images/sections/partners/beetv.svg',
	},
	{
		name: 'oq',
		img: '/images/sections/partners/oq.png',
	},
	{
		name: 'izi',
		img: '/images/sections/partners/izi.png',
	},
	{
		name: 'adfinex',
		img: '/images/sections/partners/adfinex.png',
	},
	{
		name: 'assorti',
		img: '/images/sections/partners/assorti.svg',
	},
	{
		name: 'akfa-build',
		img: '/images/sections/partners/akfa-build.png',
	},
	{
		name: 'flo',
		img: '/images/sections/partners/flo.svg',
	},
	{
		name: 'centrumair',
		img: '/images/sections/partners/centrumair.png',
	},
	{
		name: 'purplepatch',
		img: '/images/sections/partners/purplepatch.svg',
	},
	{
		name: 'bidvol',
		img: '/images/sections/partners/bidvol.png',
	},
	{
		name: 'wizads',
		img: '/images/sections/partners/wizads.png',
	},
	{
		name: 'eskimi',
		img: '/images/sections/partners/eskimi.png',
	},
	{
		name: 'geemee',
		img: '/images/sections/partners/geemee.png',
	},
]

export const MAIN_PARTNERS: PartnerItem[] = PUBLISHERS_PARTNERS
